import {Container, StorableSummaryExtras} from 'constants/SampleConstants';
import {
  TransferOperationList,
  TransferOperationParams,
  TransferTableModel,
} from 'notebook/transfer-tables/TransferTableConstants';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import EntryStore from 'stores/EntryStore';
import * as net from 'util/Net';
import {StageRunSample} from 'workflows/WorkflowConstants';

export interface CreateTransferTableParams {
  name: string;
  containerSchemaId: string;
  parentStorableIsGrid: boolean;
  entryId: string;
}

export interface CreateTransferTableResponse {
  transferTable: TransferTableModel;
  transferOperationList: TransferOperationList;
}

export function createTransferTable({
  name,
  containerSchemaId,
  parentStorableIsGrid,
  entryId,
}: CreateTransferTableParams): Promise<CreateTransferTableResponse> {
  return net.postJSONPromise({
    url: `/1/api/workflows/transfer-tables`,
    data: {name, containerSchemaId, parentStorableIsGrid, entryId},
  });
}

export interface TransferSamplesResponse {
  stageRunSamples: Array<StageRunSample>;
  containersById: {[containerId: string]: Container};
  storableSummaryExtras: StorableSummaryExtras;
}

export interface TransferSamplesParams {
  entryId: string;
  transferTableProvenanceUuid: string;
  containerSchemaId: string;
  operations: Array<TransferOperationParams>;
}

export function transferSamples({
  entryId,
  transferTableProvenanceUuid,
  containerSchemaId,
  operations,
}: TransferSamplesParams): Promise<TransferSamplesResponse> {
  return net.postJSONPromise({
    url: `/1/api/entries/${entryId}/transfer-samples`,
    data: {
      provenanceUuid: transferTableProvenanceUuid,
      containerSchemaId,
      operations,
    },
  });
}
